import {Icon, SegmentedControl} from '@forecast-it/design-system';

export type TicketView = 'list' | 'board';

interface Props {
	value: TicketView;
	onChange: (next: TicketView) => void;
}

/**
 * The queue's "change how I'm looking at this" switch. Icon-only and compact: it
 * sits beside the page's primary action, where a pair of labelled buttons would
 * compete with it. Each segment is still named for assistive tech through `label`.
 */
export function ViewToggle({value, onChange}: Props) {
	return (
		<SegmentedControl
			value={value}
			onValueChange={(next: string) => next && onChange(next as TicketView)}
			label="View"
			data-cy="ticket-view-toggle"
		>
			<SegmentedControl.Item value="list" label="List" data-cy="ticket-view-list">
				<Icon icon="list" size="s" />
			</SegmentedControl.Item>
			<SegmentedControl.Item value="board" label="Board" data-cy="ticket-view-board">
				<Icon icon="grid" size="s" />
			</SegmentedControl.Item>
		</SegmentedControl>
	);
}
